import { Component, Input } from '@angular/core';

@Component({
  selector: 'split-text-key-value',
  templateUrl: './split-text-key-value.component.html',
  styleUrls: ['./split-text-key-value.component.scss']
})
export class SplitTextKeyValueComponent {
  @Input() key: string = '';
  @Input() value: string | null = '';
}
